export default __webpack_public_path__ + "static/media/ModernBG.47117149.webp";